module.exports = __webpack_public_path__ + "media/images/login-bg2-a251c48ef07a2f214c19543101d1a2a5.svg";